import {ScoreCalculator} from '../common/score-calculator';
import {PlacedBin} from '../placed-bin';

export class OrientationScoreCalculator extends ScoreCalculator {

    public override calc(placedBin: PlacedBin): number {
        const bins: PlacedBin[] = this.placedBins.concat([placedBin]);
        const spaceW = Math.max(...bins.map(bin => bin.right)) - Math.min(...bins.map(bin => bin.x));
        const spaceH = Math.max(...bins.map(bin => bin.bottom)) - Math.min(...bins.map(bin => bin.y));

        return (spaceW > spaceH && this.board.w > this.board.h) || (spaceW < spaceH && this.board.w < this.board.h)
            ? 100
            : 0;
    }

}
